// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2jy32","topBottomGutter":"Layout_topBottomGutter__2Wjev"};